export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/portrait.a372f1f.svg";